import { render, staticRenderFns } from "./ResForm.vue?vue&type=template&id=74476e64&"
import script from "./ResForm.vue?vue&type=script&lang=js&"
export * from "./ResForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74476e64')) {
      api.createRecord('74476e64', component.options)
    } else {
      api.reload('74476e64', component.options)
    }
    module.hot.accept("./ResForm.vue?vue&type=template&id=74476e64&", function () {
      api.rerender('74476e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/ResForm.vue"
export default component.exports